/**
 * DecantsLab Header Menu
 * Archivo: assets/dl-header-menu.js
 *
 * Objetivo:
 * - Sacar JS inline de luxury-header-menu.liquid.
 * - Manejar menú móvil.
 * - Manejar acordeones móviles.
 * - Manejar quick add del mega menú vía DecantsCart.
 * - Cargar imágenes del mega menú solo al interactuar.
 */

(function () {
  'use strict';

  if (window.DecantsHeaderMenu && window.DecantsHeaderMenu.__initialized) return;

  function getMobileDrawer() {
    return document.getElementById('MobileMenuDrawer');
  }

  function getMobileOverlay() {
    return document.getElementById('MobileOverlay');
  }

  function lockScroll() {
    document.body.classList.add('decants-lock-scroll');
    document.documentElement.classList.add('decants-lock-scroll');
  }

  function unlockScroll() {
    document.body.classList.remove('decants-lock-scroll');
    document.documentElement.classList.remove('decants-lock-scroll');
  }

  function setMobileMenu(open) {
    const drawer = getMobileDrawer();
    const overlay = getMobileOverlay();

    if (!drawer || !overlay) return;

    drawer.classList.toggle('open', Boolean(open));
    overlay.classList.toggle('open', Boolean(open));

    if (open) {
      lockScroll();
    } else {
      unlockScroll();
    }
  }

  function toggleMobileMenu(force) {
    const drawer = getMobileDrawer();
    if (!drawer) return;

    const shouldOpen =
      typeof force === 'boolean'
        ? force
        : !drawer.classList.contains('open');

    setMobileMenu(shouldOpen);
  }

  function closeAllAccordions(exceptButton) {
    document.querySelectorAll('[data-dl-accordion]').forEach(function (button) {
      if (button === exceptButton) return;

      const submenu = button.nextElementSibling;
      const icon = button.querySelector('.plus');

      button.classList.remove('active-group-mobile');
      button.setAttribute('aria-expanded', 'false');

      if (submenu) {
        submenu.style.maxHeight = null;
      }

      if (icon) {
        icon.textContent = '+';
      }
    });
  }

  function toggleAccordion(button) {
    if (!button) return;

    const submenu = button.nextElementSibling;
    const icon = button.querySelector('.plus');

    if (!submenu) return;

    const isOpen = Boolean(submenu.style.maxHeight);

    closeAllAccordions(button);

    if (isOpen) {
      submenu.style.maxHeight = null;
      button.classList.remove('active-group-mobile');
      button.setAttribute('aria-expanded', 'false');

      if (icon) icon.textContent = '+';
    } else {
      submenu.style.maxHeight = submenu.scrollHeight + 'px';
      button.classList.add('active-group-mobile');
      button.setAttribute('aria-expanded', 'true');

      if (icon) icon.textContent = '−';
    }
  }

  function loadMegaImage(image) {
    if (!image || image.dataset.dlMegaLoaded === 'true') return;

    const src = image.getAttribute('data-dl-mega-src');
    const srcset = image.getAttribute('data-dl-mega-srcset');

    if (srcset) {
      image.setAttribute('srcset', srcset);
    }

    if (src) {
      image.setAttribute('src', src);
    }

    image.dataset.dlMegaLoaded = 'true';
  }

  function loadMegaImages(root) {
    const scope = root || document;

    scope.querySelectorAll('img[data-dl-mega-src], img[data-dl-mega-srcset]').forEach(loadMegaImage);
  }

  async function submitMenuQuickAdd(event, forcedForm) {
    event.preventDefault();

    const form =
        forcedForm ||
        event.target.closest('[data-dl-menu-quickadd]') ||
        event.target.closest('form') ||
        event.currentTarget;

    if (!form || form.tagName !== 'FORM') {
        console.warn('[luxury-header-menu] No se encontró un formulario válido.');
        return;
    }

    const button = form.querySelector('button[type="submit"], button');
    const originalHTML = button ? button.innerHTML : '';

    if (!window.DecantsCart || typeof window.DecantsCart.addForm !== 'function') {
        console.warn('[DecantsLab] DecantsCart no está disponible.');
        return;
    }

    try {
        if (button) {
        button.innerHTML = 'AÑADIENDO...';
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        }

        await window.DecantsCart.addForm(form, {
        openDrawer: true,
        source: 'luxury-header-menu',
        });

        if (button) {
        button.innerHTML = '¡LISTO!';
        }
    } catch (error) {
        console.error('[luxury-header-menu] Error adding to cart:', error);

        if (button) {
        button.innerHTML = 'ERROR';
        }
    } finally {
        if (button) {
        window.setTimeout(function () {
            button.innerHTML = originalHTML;
            button.disabled = false;
            button.removeAttribute('aria-disabled');
        }, 1200);
        }
    }
  }

  document.addEventListener('click', function (event) {
    const mobileToggle = event.target.closest('[data-dl-mobile-menu-toggle]');
    if (mobileToggle) {
      event.preventDefault();
      toggleMobileMenu();
      return;
    }

    const accordionButton = event.target.closest('[data-dl-accordion]');
    if (accordionButton) {
      event.preventDefault();
      toggleAccordion(accordionButton);
      return;
    }

    const overlay = event.target.closest('[data-dl-mobile-menu-overlay]');
    if (overlay) {
      event.preventDefault();
      setMobileMenu(false);
    }
  });

  document.addEventListener('submit', function (event) {
    const form = event.target.closest('[data-dl-menu-quickadd]');
    if (!form) return;

    submitMenuQuickAdd(event, form);
  });

  document.addEventListener(
    'pointerenter',
    function (event) {
      const menuItem = event.target.closest && event.target.closest('.has-mega');
      if (!menuItem) return;

      loadMegaImages(menuItem);
    },
    true
  );

  document.addEventListener('focusin', function (event) {
    const menuItem = event.target.closest && event.target.closest('.has-mega');
    if (!menuItem) return;

    loadMegaImages(menuItem);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      setMobileMenu(false);
    }
  });

  /**
   * Fallback temporal por si queda algún onclick/onsubmit antiguo.
   * Después, cuando confirmemos que todo funciona, se puede mantener o eliminar.
   */
  window.toggleMobileMenu = toggleMobileMenu;
  window.toggleAccordion = toggleAccordion;
  window.submitMenuQuickAdd = submitMenuQuickAdd;

  window.DecantsHeaderMenu = {
    __initialized: true,
    openMobileMenu: function () {
      setMobileMenu(true);
    },
    closeMobileMenu: function () {
      setMobileMenu(false);
    },
    toggleMobileMenu: toggleMobileMenu,
    toggleAccordion: toggleAccordion,
    loadMegaImages: loadMegaImages,
    submitMenuQuickAdd: submitMenuQuickAdd,
  };
})();